// 운영 설정에 따라 작품의 메타정보와 사용자 티켓 충전 정보가 다를 수 있습니다. 메타정보보다 사용자의 정보를 우선하여 노출합니다.
import {Maybe} from '../../../../../../graphql/generated/types';

export function getDisplayWaitfreePeriodByMinute({
  chargedPeriodByMinute,
  waitfreePeriodByMinute,
}: {
  chargedPeriodByMinute?: Maybe<number>;
  waitfreePeriodByMinute?: Maybe<number>;
}) {
  return chargedPeriodByMinute ? chargedPeriodByMinute : waitfreePeriodByMinute;
}
